import { Record } from 'immutable';

const ChainRecord = Record({
    chainCode: null,
    name: null
});

export class Chain extends ChainRecord {
    chainCode: string;
    name: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/chain-brand/chain.ts